// extracted by mini-css-extract-plugin
module.exports = {"messages":"styles_messages__3b64s","messageOrigin":"styles_messageOrigin__1ZTgb","messageSender":"styles_messageSender__2r3ga"};